module.exports = __webpack_public_path__ + "logo.a70592b6bb62207cad14.png";